import { defineMessages } from '@dragonraider5/react-intl'

import {
  LEGAL_FORM_VALUES,
  SIZES_VALUES,
  PROJECTIONS_VALUES
} from '../../constants'

export default defineMessages({
  [`legalFormTypes${LEGAL_FORM_VALUES.SL}`]: {
    id: 'containers.Applications.steps.forms.legalFormTypes.values.SL',
    description: 'Legal Form Type text for SL',
    defaultMessage: 'Sociedad Limitada'
  },
  [`legalFormTypes${LEGAL_FORM_VALUES.SA}`]: {
    id: 'containers.Applications.steps.forms.legalFormTypes.values.SA',
    description: 'Legal Form Type text for SA',
    defaultMessage: 'Sociedad Anónima'
  },
  [`legalFormTypes${LEGAL_FORM_VALUES.FUNDATION}`]: {
    id: 'containers.Applications.steps.forms.legalFormTypes.values.FUNDATION',
    description: 'Legal Form Type text for FUNDATION',
    defaultMessage: 'Fundación'
  },
  [`legalFormTypes${LEGAL_FORM_VALUES.ASSOCIATION}`]: {
    id: 'containers.Applications.steps.forms.legalFormTypes.values.ASSOCIATION',
    description: 'Legal Form Type text for ASSOCIATION',
    defaultMessage: 'Asociación'
  },
  [`legalFormTypes${LEGAL_FORM_VALUES.FREELANCE}`]: {
    id: 'containers.Applications.steps.forms.legalFormTypes.values.FREELANCE',
    description: 'Legal Form Type text for FREELANCE',
    defaultMessage: 'Autónomo/a'
  },
  [`legalFormTypes${LEGAL_FORM_VALUES.COOPERATIVE}`]: {
    id: 'containers.Applications.steps.forms.legalFormTypes.values.COOPERATIVE',
    description: 'Legal Form Type text for COOPERATIVE',
    defaultMessage: 'Cooperativa'
  },
  [`legalFormTypes${LEGAL_FORM_VALUES.CIVIL}`]: {
    id: 'containers.Applications.steps.forms.legalFormTypes.values.CIVIL',
    description: 'Legal Form Type text for CIVIL',
    defaultMessage: 'Sociedad Civil'
  },
  [`legalFormTypes${LEGAL_FORM_VALUES.COMMUNITIES_GOODS}`]: {
    id: 'containers.Applications.steps.forms.legalFormTypes.values.COMMUNITIES_GOODS',
    description: 'Legal Form Type text for COMMUNITIES_GOODS',
    defaultMessage: 'Comunidad de bienes'
  },
  [`legalFormTypes${LEGAL_FORM_VALUES.AIE}`]: {
    id: 'containers.Applications.steps.forms.legalFormTypes.values.AIE',
    description: 'Legal Form Type text for AIE',
    defaultMessage: 'Agrupación de interés económico'
  },
  [`legalFormTypes${LEGAL_FORM_VALUES.SAT}`]: {
    id: 'containers.Applications.steps.forms.legalFormTypes.values.SAT',
    description: 'Legal Form Type text for SAT',
    defaultMessage: 'Sociedad agraria de transformación'
  },
  [`legalFormTypes${LEGAL_FORM_VALUES.CONGREGATIONS}`]: {
    id: 'containers.Applications.steps.forms.legalFormTypes.values.CONGREGATIONS',
    description: 'Legal Form Type text for CONGREGATIONS',
    defaultMessage: 'Congregaciones e instituciones religiosas  '
  },
  [`legalFormTypes${LEGAL_FORM_VALUES.UTE}`]: {
    id: 'containers.Applications.steps.forms.legalFormTypes.values.UTE',
    description: 'Legal Form Type text for UTE',
    defaultMessage: 'Uniones temporales de empresas'
  },
  [`legalFormTypes${LEGAL_FORM_VALUES.OTHERS}`]: {
    id: 'containers.Applications.steps.forms.legalFormTypes.values.OTHERS',
    description: 'Legal Form Type text for OTHERS',
    defaultMessage: 'Otros'
  },
  [`sizesTypes${SIZES_VALUES.SMALL}`]: {
    id: 'containers.Applications.steps.forms.sizesTypes.values.SMALL',
    description: 'Sizes Type text for SMALL',
    defaultMessage: 'Pequeña'
  },
  [`sizesTypes${SIZES_VALUES.MEDIUM}`]: {
    id: 'containers.Applications.steps.forms.sizesTypes.values.MEDIUM',
    description: 'Sizes Type text for MEDIUM',
    defaultMessage: 'Mediana'
  },
  [`sizesTypes${SIZES_VALUES.BIG}`]: {
    id: 'containers.Applications.steps.forms.sizesTypes.values.BIG',
    description: 'Sizes Type text for BIG',
    defaultMessage: 'Grande'
  },
  [`projectionTypes${PROJECTIONS_VALUES.HIGHER}`]: {
    id: 'containers.Applications.steps.forms.sizesTypes.values.HIGHER',
    description: 'Sizes Type text for HIGHER',
    defaultMessage: 'Significativamente superior al año anterior'
  },
  [`projectionTypes${PROJECTIONS_VALUES.SIMILAR}`]: {
    id: 'containers.Applications.steps.forms.sizesTypes.values.SIMILAR',
    description: 'Sizes Type text for SIMILAR',
    defaultMessage: 'Similar al año anterior o un poco superior'
  },
  [`projectionTypes${PROJECTIONS_VALUES.LOWER}`]: {
    id: 'containers.Applications.steps.forms.sizesTypes.values.LOWER',
    description: 'Sizes Type text for LOWER',
    defaultMessage: 'Inferior al anterior'
  },
})
